// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Vt-z","tooltipWrapper":"Wt-z","icon":"Xt-z","tooltip":"Yt-z","content":"Zt-z"};